import React from 'react';
import { Table, Form, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const TablaEmpresasYaProgramadas = ({
    candidatasPaginadas,
    licenciasSeleccionadas,
    todasSeleccionadasPaginaActual,
    toggleSeleccionarTodo,
    toggleSeleccion,
    cargando,
    formatearFechaLarga,
    formatearFechaCorta,
    copiarAlPortapapeles,
    toggleOrdenColumna,
    ordenDias,
    isAdmin = true
}) => (
    <div className="table-responsive">
        <Table striped hover className="fs--1 mb-0 align-middle text-nowrap">
            <thead className="bg-200 text-900">
                <tr>
                    {isAdmin && (
                        <th className="ps-2" style={{ width: '28px' }}>
                            <Form.Check
                                type="checkbox"
                                checked={todasSeleccionadasPaginaActual}
                                onChange={toggleSeleccionarTodo}
                                disabled={candidatasPaginadas.length === 0}
                            />
                        </th>
                    )}
                    <th>ID</th>
                    <th>Empresa</th>
                    <th>Tipo Licencia</th>
                    <th>Servidor / Base de Datos</th>
                    <th
                        className="cursor-pointer user-select-none text-primary"
                        onClick={toggleOrdenColumna}
                        title="Haz clic para alternar orden por días vencidos (Mayor / Menor)"
                    >
                        Vencimiento / Días {ordenDias === 'DIAS_DESC' ? '↓' : '↑'}
                    </th>
                    <th>Fecha en que se agregó</th>
                    <th className="pe-2">UUID Empresa</th>
                </tr>
            </thead>
            <tbody>
                {candidatasPaginadas.length > 0 ? (
                    candidatasPaginadas.map((row, idx) => (
                        <tr key={row.idLicencia || idx}>
                            {isAdmin && (
                                <td className="ps-2">
                                    <Form.Check
                                        type="checkbox"
                                        checked={!!licenciasSeleccionadas.find(l => l.idLicencia === row.idLicencia)}
                                        onChange={() => toggleSeleccion(row)}
                                    />
                                </td>
                            )}
                            <td>
                                <Link to={"/licencias/detalle/" + row.idLicencia}>
                                    <strong>{row.idLicencia}</strong>
                                </Link>
                            </td>
                            <td>
                                <span className="d-inline-block text-truncate fs--1 text-800 fw-semi-bold" style={{ maxWidth: '220px' }}>
                                    {row.vNombreEmpresa || 'Sin Nombre'}
                                </span>
                            </td>
                            <td>
                                <Badge
                                    bg={row.vTipoLicencia === 'Nube' ? 'soft-primary' : 'soft-info'}
                                    className={row.vTipoLicencia === 'Nube' ? 'text-primary' : 'text-info'}
                                >
                                    {row.vTipoLicencia || 'Desconocido'}
                                </Badge>
                            </td>
                            <td>
                                <div>
                                    <div className="text-700 fs--2">{row.vServer || 'N/A'}</div>
                                    <div className="text-700 fs--2">{row.vDatabase || 'N/A'}</div>
                                </div>
                                {row.bTieneLicenciaVigente && (
                                    <div className="mt-1 p-1 px-2 border border-warning rounded bg-white">
                                        <div className="d-flex align-items-center gap-1 mb-1">
                                            <Badge bg="soft-warning" className="text-warning">
                                                Lic. Vigente ({row.vTipoLicenciaVigente || 'Activa'})
                                            </Badge>
                                            {(row.vServerVigente !== row.vServer || row.vDatabaseVigente !== row.vDatabase) && (
                                                <Badge bg="soft-info" className="text-info fs--2" title="La licencia activa está en otra BD o servidor diferente">
                                                    Otra BD
                                                </Badge>
                                            )}
                                        </div>
                                        <div className="text-800 fs--2"><strong>Servidor:</strong> {row.vServerVigente || 'N/A'}</div>
                                        <div className="text-800 fs--2"><strong>BD:</strong> {row.vDatabaseVigente || 'N/A'}</div>
                                        {row.dFinLicenciaVigente && (
                                            <div className="text-600 fs--2"><strong>Vence:</strong> {formatearFechaCorta(row.dFinLicenciaVigente)}</div>
                                        )}
                                    </div>
                                )}
                            </td>
                            <td>
                                <div>
                                    <div className="fs--1 text-700">{formatearFechaLarga(row.dFechaVencimiento)}</div>
                                    <div className="mt-1">
                                        <Badge bg="soft-danger" className="text-danger rounded-pill px-2 py-1">
                                            {row.iDiasVencidos} días
                                        </Badge>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <span className="fs--1 text-700">
                                    {formatearFechaCorta(row.dFechaProgramacion)}
                                </span>
                            </td>
                            <td className="pe-2">
                                <span
                                    className="text-700 fs--2 font-monospace cursor-pointer"
                                    onClick={() => copiarAlPortapapeles(row.vUUIDEmpresa)}
                                    title="Haz clic para copiar UUID"
                                >
                                    {row.vUUIDEmpresa || 'N/A'}
                                </span>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={8} className="text-center py-4 text-muted fs--1">
                            {cargando ? 'Cargando datos...' : 'No hay empresas programadas para borrado.'}
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    </div>
);

export default TablaEmpresasYaProgramadas;
